import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { ClosableModalWithErrorResponseModel } from '../../../../components/base/closable-modal-with-error-response-model';
import { NotificationService, ReportRepositoryService } from '../../../../services';
import { ModalService } from '../../../../modules/modal';
import { Report } from '../../../../models';

@Component({
  templateUrl: './edit-report-title-modal.component.html',
  styleUrls: ['./edit-report-title-modal.component.scss']
})
export class EditReportTitleModalComponent extends ClosableModalWithErrorResponseModel<void> implements OnInit, OnDestroy {

  data: Report;
  newReportTitleFormControl: FormControl;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _reportRepositoryService: ReportRepositoryService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.newReportTitleFormControl = new FormControl(this.data.name, Validators.required);
  }

  save(): void {
    if (this.newReportTitleFormControl.valid) { this.saveReportTitle(); }
  }

  exitModal(): void { this.closeAllModals(); }

  private saveReportTitle(): void {
    this._reportRepositoryService.updateTitle(this.newReportTitleFormControl.value, this.data.reportId).subscribe(() => {
      this.success();
      this.exitModal();
    });
  }

}
